import { createAction, props } from '@ngrx/store';
import { PhoneStatusEnum } from 'src/app/models/phoneStatus';

export const phoneChangeStatus = createAction('[Phone] phone change status', props<{status: PhoneStatusEnum}>());